import { createContext, Dispatch, SetStateAction, useCallback, useContext, useMemo, useState } from 'react';

type ContextProps = {
    filters: any[];
    setFilters: Dispatch<SetStateAction<any[]>>;
    searchTerms: string;
    setSearchTerms: Dispatch<SetStateAction<string>>;
    handleClearFilters: () => void;
};

const defaultValues: ContextProps = {
    filters: [],
    setFilters: (v: any[]) => {},
    searchTerms: '',
    setSearchTerms: (v: string) => {},
    handleClearFilters: () => {},
};

type Props = {
    children: React.ReactNode;
};

export type ItemCheckbox = {
    label: string;
    id: number;
    name: 'Sin stock' | 'Con descuento' | 'Con genéricos';
    isChecked: boolean;
};

const FiltersContext = createContext<ContextProps>(defaultValues);

export const FiltersProvider = ({ children }: Props) => {
    const [filters, setFilters] = useState<ItemCheckbox[]>(defaultValues.filters);
    const [searchTerms, setSearchTerms] = useState<string>(defaultValues.searchTerms);

    const handleClearFilters = useCallback(() => {
        setFilters((prevState) => {
            return prevState.map((filter) => ({
                ...filter,
                isChecked: false,
            }));
        });

        setSearchTerms('');
    }, []);

    const value: ContextProps = useMemo(
        () => ({
            filters,
            setFilters,
            searchTerms,
            setSearchTerms,
            handleClearFilters,
        }),
        [filters, searchTerms],
    );

    return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};

export const useFiltersContext = () => useContext(FiltersContext);
